import { defineAllowRoutes } from '@router/settingMethods'
import AccountInput from '@views/account/AccountInput.vue'
import AccountConfirm from '@views/account/AccountConfirm.vue'

export default [
  {
    path: '/user/account/input',
    name: 'Account',
    component: AccountInput,
    meta: {
      nav: 'back',
      title: '登録情報編集',
      gaTitle: '登録情報-編集'
    }
  },
  {
    path: '/user/account/confirm',
    name: 'AccountConfirm',
    component: AccountConfirm,
    meta: {
      nav: 'back',
      title: '登録情報編集',
      gaTitle: '登録情報-編集-確認'
    }
  }
]
